export default "__VITE_ASSET__20dd06c5__"